<form #workareaForm="ngForm">
    <div class="row">
        <div class="col-24 col-md-8">
            <mat-form-field [floatLabel]="true" class="w-100">
                <mat-select
                    #type="ngModel"
                    [disabled]="Functionalities.GeoRestricted | hasFunctionality"
                    (valueChange)="inputChanged($event)"
                    [(ngModel)]="workarea.extra.damage"
                    errorState="type.errors?.required && (type.dirty || workareaForm.submitted)"
                    name="type"
                    placeholder="Type"
                    required>
                    <mat-option [value]="undefined" disabled selected>Type</mat-option>
                    @for (type of fieldOptions['damage']; track type) {
                        <mat-option [value]="type">{{ type }}</mat-option>
                    }
                </mat-select>
                <mat-label>Type</mat-label>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-8">
            <mat-form-field [floatLabel]="true" class="w-100">
                <mat-select
                    #location_damage="ngModel"
                    [disabled]="Functionalities.GeoRestricted | hasFunctionality"
                    (valueChange)="inputChanged($event)"
                    [(ngModel)]="workarea.extra.location_damage"
                    errorState="location_damage.errors?.required && (location_damage.dirty || workareaForm.submitted)"
                    name="location_damage"
                    placeholder="Schade Locatie"
                    required>
                    <mat-option [value]="undefined" disabled selected>Schade Locatie</mat-option>
                    @for (type of fieldOptions['location_damage']; track type) {
                        <mat-option [value]="type">{{ type }}</mat-option>
                    }
                </mat-select>
                <mat-label>Schade Locatie</mat-label>
            </mat-form-field>
        </div>
        @if ([Functionalities.GeoManage, Functionalities.GeoRestricted] | hasFunctionality) {
            <div class="col-24 col-md-8">
                <mat-form-field [floatLabel]="true" class="w-100">
                    <mat-select
                        (ngModelChange)="statusChange($event)"
                        [(ngModel)]="workarea.status_id"
                        required
                        [disabled]="
                            (Functionalities.GeoRestricted | hasFunctionality) &&
                            ([130, 131] | filter: workarea.status_id)?.length < 1
                        "
                        name="status"
                        placeholder="Status">
                        @for (status of statuses; track status) {
                            <mat-option
                                [value]="status.id"
                                [disabled]="status | statusDisabled: workarea.extra.waymark : workarea.status_id">
                                {{ status.name }}
                            </mat-option>
                        }
                    </mat-select>
                    <mat-label>Status</mat-label>
                </mat-form-field>
            </div>
        }
    </div>
    <div class="row">
        <div class="col-24">
            <mat-form-field [floatLabel]="true" class="w-100">
                <textarea
                    #comments="ngModel"
                    [(ngModel)]="workarea.comments"
                    cdkAutosizeMinRows="4"
                    [disabled]="
                        (Functionalities.GeoRestricted | hasFunctionality) &&
                        ([130, 131] | filter: workarea.status_id)?.length < 1
                    "
                    cdkTextareaAutosize
                    matInput
                    maxlength="10000"
                    name="comments"
                    placeholder="Opmerkingen"></textarea>
                <mat-label>Opmerkingen</mat-label>
                <mat-hint>Maximaal 10.000 tekens</mat-hint>
                <mat-hint align="end">{{ workarea.comments?.length || 0 }} / 10000</mat-hint>
                <mat-error [control]="comments"></mat-error>
            </mat-form-field>
        </div>
    </div>
    <mat-divider class="pb-4 pt-2"></mat-divider>
    @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
        <div class="row">
            <div class="col-24 col-md-12">
                <div class="row">
                    @if (fieldOptions['toplayer']) {
                        <div class="col-24">
                            <mat-form-field [floatLabel]="true" class="w-100">
                                <mat-select
                                    (selectionChange)="toplayerChange($event)"
                                    [(ngModel)]="workarea.extra.toplayer"
                                    [required]="workarea.extra.damage !== 'Scheuren'"
                                    name="toplayer"
                                    placeholder="Toplaag">
                                    <mat-option disabled>Toplaag</mat-option>
                                    <mat-option
                                        value="{{
                                            fieldOptions['toplayer'].indexOf(workarea.extra.toplayer) === -1
                                                ? workarea.extra.toplayer
                                                : ''
                                        }}">
                                        Anders namelijk
                                    </mat-option>
                                    @for (item of fieldOptions['toplayer']; track item) {
                                        <mat-option [value]="item">{{ item }}</mat-option>
                                    }
                                </mat-select>
                                <mat-label>Toplaag</mat-label>
                            </mat-form-field>
                        </div>
                    }
                    @if (
                        (workarea.extra.toplayer === '' || workarea.extra.toplayer?.length > 0) &&
                        fieldOptions['toplayer'] &&
                        fieldOptions['toplayer'].indexOf(workarea.extra.toplayer) === -1
                    ) {
                        <div class="col-24">
                            <mat-form-field [floatLabel]="true" class="w-100">
                                <input
                                    [(ngModel)]="workarea.extra.toplayer"
                                    matInput
                                    name="toplayer"
                                    placeholder="Beschrijving toplaag"
                                    required
                                    type="text" />
                                <mat-label>Beschrijving toplaag</mat-label>
                            </mat-form-field>
                        </div>
                    }
                    <div class="col-24">
                        <mat-form-field [floatLabel]="true" class="w-100">
                            <mat-select
                                [(ngModel)]="workarea.extra.interlayer"
                                name="interlayer"
                                placeholder="Tussenlaag">
                                <mat-option disabled>Tussenlaag</mat-option>
                                @for (item of fieldOptions['interlayer']; track item) {
                                    <mat-option [value]="item"> {{ item }}</mat-option>
                                }
                            </mat-select>
                            <mat-label>Tussenlaag</mat-label>
                        </mat-form-field>
                    </div>
                    <div class="col-24">
                        <mat-form-field [floatLabel]="true" class="w-100">
                            <mat-select
                                [(ngModel)]="workarea.extra.bottomlayer"
                                [required]="workarea.extra.klinkerfloor"
                                name="bottomlayer"
                                placeholder="Onderlaag">
                                <mat-option disabled>Onderlaag</mat-option>
                                @for (item of fieldOptions['bottomlayer']; track item) {
                                    <mat-option [value]="item"> {{ item }}</mat-option>
                                }
                            </mat-select>
                            <mat-label>Onderlaag</mat-label>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-24 col-md-12">
                <div class="row">
                    <div class="col-24">
                        <mat-form-field [floatLabel]="true" class="w-100">
                            <mat-select
                                [(ngModel)]="workarea.extra.execution"
                                name="execution"
                                placeholder="Uitvoering"
                                required>
                                <mat-option disabled>Uitvoering</mat-option>
                                @for (item of fieldOptions['execution']; track item) {
                                    <mat-option [value]="item"> {{ item }}</mat-option>
                                }
                            </mat-select>
                            <mat-label>Uitvoering</mat-label>
                        </mat-form-field>
                        <mat-form-field [floatLabel]="true" class="w-100">
                            <mat-select
                                [(ngModel)]="workarea.extra.genpriority"
                                name="genpriority"
                                placeholder="Prioriteit">
                                <mat-option disabled>Prioriteit</mat-option>
                                @for (item of fieldOptions['genpriority']; track item) {
                                    <mat-option [value]="item"> {{ item }}</mat-option>
                                }
                            </mat-select>
                            <mat-label>Prioriteit</mat-label>
                        </mat-form-field>
                        <div class="pb-3 pt-3">
                            <mat-checkbox
                                (ngModelChange)="changeKlinkerfloor($event)"
                                [(ngModel)]="workarea.extra.klinkerfloor"
                                color="primary"
                                name="klinkerfloor">
                                Betreft klinkervak
                            </mat-checkbox>
                        </div>
                        <div>
                            <mat-checkbox
                                [(ngModel)]="workarea.extra.reinforcementgrid"
                                color="primary"
                                name="reinforcementgrid">
                                Bewapeningsnet gebruiken
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    <div class="row">
        <div class="col-24 col-md-12">
            <mat-form-field [floatLabel]="true" class="w-100">
                <mat-select
                    [(ngModel)]="workarea.extra.waymark"
                    name="waymark"
                    required
                    [disabled]="
                        (Functionalities.GeoRestricted | hasFunctionality) &&
                        ([130, 131] | filter: workarea.status_id)?.length < 1
                    "
                    placeholder="Wegmarkering">
                    <mat-option disabled>Wegmarkering</mat-option>
                    @for (item of fieldOptions['waymark']; track item) {
                        <mat-option [value]="item"> {{ item }}</mat-option>
                    }
                </mat-select>
                <mat-label>Wegmarkering</mat-label>
            </mat-form-field>
        </div>
        @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
            <div class="col-24 col-md-12">
                <mat-form-field [floatLabel]="true" class="w-100">
                    <mat-select
                        [(ngModel)]="workarea.extra.roadblock"
                        name="roadblock"
                        placeholder="Afzetting"
                        [required]="workarea.extra.damage !== 'Scheuren'">
                        <mat-option disabled>Afzetting</mat-option>
                        @for (item of fieldOptions['roadblock']; track item) {
                            <mat-option [value]="item">{{ item }}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Afzetting</mat-label>
                </mat-form-field>
            </div>
        }
    </div>
    <mat-divider class="pb-4 pt-2"></mat-divider>
    @for (area of workarea.areas; track area; let i = $index) {
        <div class="row pt-2">
            <div [class.col-12]="workarea.extra.damage == 'Scheuren'" class="col-6 col-md-6">
                <mat-form-field [floatLabel]="true" class="w-100">
                    <input
                        [(ngModel)]="area.length"
                        (ngModelChange)="calculateAreasTotal(workarea.areas)"
                        (paste)="onLengthPaste($event, area, i)"
                        [disabled]="Functionalities.GeoRestricted | hasFunctionality"
                        matInput
                        name="length{{ i }}"
                        placeholder="Lengte (m)"
                        step="0.01"
                        type="text"
                        appDecimalInput
                        [decimalInput]="2" />
                    <mat-label>Lengte (m)</mat-label>
                </mat-form-field>
            </div>
            @if (workarea.extra.damage != 'Scheuren' && !(Functionalities.GeoRestricted | hasFunctionality)) {
                <div class="col-6 col-md-6">
                    <mat-form-field [floatLabel]="true" class="w-100">
                        <input
                            [(ngModel)]="area.width"
                            (ngModelChange)="calculateAreasTotal(workarea.areas)"
                            matInput
                            name="width{{ i }}"
                            placeholder="Breedte (m)"
                            step="0.01"
                            type="text"
                            appDecimalInput
                            [decimalInput]="2" />
                        <mat-label>Breedte (m)</mat-label>
                    </mat-form-field>
                </div>
            }
            @if (!(Functionalities.GeoRestricted | hasFunctionality)) {
                <div class="col-12 col-md-12 d-flex">
                    <mat-form-field [floatLabel]="true" class="spacer" style="overflow: hidden">
                        <input
                            disabled
                            matInput
                            placeholder="Oppervlakte {{ workarea.extra.damage == 'Scheuren' ? '(m)' : '(m2)' }}"
                            type="text"
                            value="{{ area.width * area.length | number: '.2' }}" />
                        <mat-label>Oppervlakte {{ workarea.extra.damage == 'Scheuren' ? '(m)' : '(m2)' }}</mat-label>
                    </mat-form-field>
                    @if (Functionalities.GeoManage | hasFunctionality) {
                        <button (click)="removeArea(area)" color="warn" mat-icon-button>
                            <mat-icon class="fa fa-remove" style="font-size: 24px"></mat-icon>
                        </button>
                    }
                </div>
            }
        </div>
    }
    @if (!(Functionalities.GeoRestricted | hasFunctionality)) {
        <div class="row pb-5">
            @if (Functionalities.GeoManage | hasFunctionality) {
                <div class="col-12">
                    <button (click)="addArea()" class="w-100" color="primary" mat-flat-button>Vlak toevoegen</button>
                </div>
            }
            <div class="col-12">
                <mat-form-field [floatLabel]="true" class="spacer d-flex">
                    <input
                        disabled
                        matInput
                        placeholder="Totaal oppervlakte {{ workarea.extra.damage == 'Scheuren' ? '(m)' : '(m2)' }}"
                        type="text"
                        value="{{ areasTotal }}" />
                    <mat-label>Totaal oppervlakte {{ workarea.extra.damage == 'Scheuren' ? '(m)' : '(m2)' }}</mat-label>
                </mat-form-field>
            </div>
        </div>
    }
</form>
